import { css } from '@emotion/react'
import { IPartnerLanding } from 'api/contentful/contentful.types'
import {
  SPartnerHeroBlock,
  SPartnerHeroImageDesktop,
  SPartnerHeroImageMobile,
  SPartnerHeroLeft,
  SPartnerHeroLeftContent,
  SPartnerHeroWrapper,
} from './PartnerHero.styled'
import { PartnerLogos } from 'components/content/partners/PartnerLogos'
import { Spacer } from 'components/spacer/Spacer'
import { Text, Title, Title_h3_default } from 'components/Typography'
import { ReactNode } from 'react'
import { BREAKPOINTS } from 'utils/styled'
import { ApiType } from 'utils/types'

export function PartnerHero(props: {
  promocode?: ApiType['PromoCodeResponse']
  partnerLandingCms?: IPartnerLanding
  children?: ReactNode
}) {
  return (
    <SPartnerHeroBlock>
      <SPartnerHeroWrapper>
        <SPartnerHeroLeft>
          <PartnerLogos
            css={css`
              align-items: flex-start;
              margin-bottom: 3rem;

              @media ${BREAKPOINTS.MD.max} {
                margin-bottom: 1rem;
              }
            `}
            orientation={'vertical'}
            promocode={props.promocode}
          />

          <SPartnerHeroImageMobile
            src={props.partnerLandingCms?.cover?.url || `/images/homepage.jpg`}
            srcSet={
              props.partnerLandingCms?.cover?.url
                ? undefined
                : `
              /images/homepage.jpg 1x,
              /images/homepage@2x.jpg 2x,
            `
            }
            alt="Partner cover image"
          />

          <SPartnerHeroLeftContent>
            <Title variant={Title_h3_default} css={{ maxWidth: '27rem' }}>
              {props.partnerLandingCms?.title}
            </Title>

            <Spacer size={[1, 1.825]} />

            <Text css={{ marginBottom: '1.75rem' }}>{props.partnerLandingCms?.description}</Text>

            {props.children}
          </SPartnerHeroLeftContent>
        </SPartnerHeroLeft>

        <SPartnerHeroImageDesktop
          src={props.partnerLandingCms?.cover?.url || `/images/homepage.jpg`}
          srcSet={
            props.partnerLandingCms?.cover?.url
              ? undefined
              : `
            /images/homepage.jpg 1x,
            /images/homepage@2x.jpg 2x,
          `
          }
          alt="Partner cover image"
        />
      </SPartnerHeroWrapper>
    </SPartnerHeroBlock>
  )
}
